import React, { useState } from 'react';
import { PaymentClient } from '@azzurri-group/dna-payment-client';
import { TextField, Typography } from '@material-ui/core';
import { Button } from 'common/components';
import { Alert } from '@material-ui/lab';
import InfoIcon from '@material-ui/icons/Info';
import { useContent } from 'content/content-provider';
import { DNA_CLIENT_NAME } from 'common/constants/payment';
import styles from './SerialNumberModal.styles';

interface SerialNumberModalProps {
  toggleModal: () => void;
}

const serialNumberRegex = /^[0-9]{10}$/;

const SerialNumberModal = ({ toggleModal }: SerialNumberModalProps) => {
  const [{ serialNumberModal }] = useContent();
  const classes = styles();

  const [error, setError] = useState<string | null>(null);

  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const { deviceSerialNumber } = e.target.elements;

    try {
      const pdqClient = new PaymentClient({
        clientName: DNA_CLIENT_NAME,
        debug: !!process.env.GATSBY_DNA_API_LOG_ENABLED,
      });

      await pdqClient.validateSerialNumber(deviceSerialNumber.value);
      window.localStorage.setItem('deviceSerialNumber', deviceSerialNumber.value);

      toggleModal();
    } catch (err: any) {
      setError(serialNumberModal.errorAlert);
    }
  };

  return (
    <div className={classes.container}>
      <Typography variant="h2" component="h1" className={classes.header}>
        {serialNumberModal.title}
      </Typography>

      <Typography variant="h4" component="h2" paragraph>
        {serialNumberModal.subTitle}
      </Typography>

      <Alert
        color="info"
        severity="info"
        variant="standard"
        icon={<InfoIcon htmlColor="black" />}
        className={classes.infoAlert}
      >
        {serialNumberModal.infoAlert}
      </Alert>

      <form onSubmit={handleSubmit}>
        <div>
          <TextField
            id="serial-number"
            name="deviceSerialNumber"
            label={serialNumberModal.label}
            fullWidth
            type="text"
            className={classes.textField}
            inputProps={{
              'data-testid': 'serial-number-input',
              inputMode: 'numeric',
              pattern: '[0-9]{10}',
            }}
            onChange={(e) => {
              const isInvalidSerialNumber = !serialNumberRegex.test(e.target.value);
              if (error) {
                setError(null);
              }
              setIsDisabled(isInvalidSerialNumber);
            }}
          />

          {error && (
            <Alert color="error" severity="error" variant="standard">
              {error}
            </Alert>
          )}
        </div>

        <Button
          aria-label="submit"
          type="submit"
          isDisabled={isDisabled}
          className={classes.submitButton}
        >
          {serialNumberModal.button}
        </Button>
      </form>
    </div>
  );
};

export default SerialNumberModal;
